import React from 'react';
import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';
export function ImpressumPage() {
  return <>
      <SEO title="Impressum" description="Impressum und rechtliche Informationen von CRMReview.de" canonicalUrl="/impressum" data-id="element-313" />

      <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-314">
        {/* Navigation */}
        <nav className="border-b border-slate-200 bg-white sticky top-0 z-50" data-id="element-315">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between" data-id="element-316">
            <Link to="/" className="font-bold text-xl tracking-tight hover:opacity-80 transition-opacity" data-id="element-317">
              CRM<span className="text-blue-600" data-id="element-318">Review</span>
              <span className="text-slate-400 font-normal" data-id="element-319">.de</span>
            </Link>
          </div>
        </nav>

        <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-320">
          <h1 className="text-3xl font-bold mb-8" data-id="element-321">Impressum</h1>

          <div className="space-y-8 text-slate-700" data-id="element-322">
            <section data-id="element-323">
              <h2 className="text-xl font-bold text-slate-900 mb-4" data-id="element-324">Adresse</h2>
              <p data-id="element-325">
                CRM Kraft LLC
                <br data-id="element-326" />
                2880 West Oakland Park Boulevard
                <br data-id="element-327" />
                33311 Florida
                <br data-id="element-328" />
                United States of America
              </p>
            </section>

            <section data-id="element-329">
              <h2 className="text-xl font-bold text-slate-900 mb-4" data-id="element-330">Kontakt</h2>
              <p data-id="element-331">
                Telefon: +4915735999071
                <br data-id="element-332" />
                E-Mail: justus@crm-kraft.de
              </p>
            </section>

            <section data-id="element-333">
              <h2 className="text-xl font-bold text-slate-900 mb-4" data-id="element-334">
                EU-Streitschlichtung
              </h2>
              <p data-id="element-335">
                Die Europäische Kommission stellt eine Plattform zur
                Online-Streitbeilegung (OS) bereit:
                <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline ml-1" data-id="element-336">
                  https://ec.europa.eu/consumers/odr/
                </a>
                .<br data-id="element-337" />
                Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </p>
            </section>

            <section data-id="element-338">
              <h2 className="text-xl font-bold text-slate-900 mb-4" data-id="element-339">
                Verbraucherstreitbeilegung/Universalschlichtungsstelle
              </h2>
              <p data-id="element-340">
                Wir sind nicht bereit oder verpflichtet, an
                Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </section>
          </div>
        </main>

        <footer className="bg-slate-50 border-t border-slate-200 py-12 mt-12" data-id="element-341">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-slate-500 text-sm" data-id="element-342">
            <div className="flex justify-center space-x-6 mb-4" data-id="element-343">
              <Link to="/impressum" className="hover:text-slate-900" data-id="element-344">
                Impressum
              </Link>
              <Link to="/datenschutz" className="hover:text-slate-900" data-id="element-345">
                Datenschutz
              </Link>
            </div>
            <p data-id="element-346">
              © {new Date().getFullYear()} CRMReview.de - Alle Rechte
              vorbehalten.
            </p>
          </div>
        </footer>
      </div>
    </>;
}